<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="pageix"></a>Maps</h2>
<table width="100%">
<colgroup>
<col width="5%"/>
<col width="95%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"><a href="#/11_chapter2#map1"> 1</a></td>
<td valign="top"><a href="#/11_chapter2#map1">Situation at Taukkyon, night of 7th/8th March</a></td>
</tr>
<tr>
<td valign="top"><span href="#/12_chapter3#map2" title="Link target outside of Sample"> 2</span></td>
<td valign="top"><span href="#/12_chapter3#map2" title="Link target outside of Sample">The longest retreat: the route from Rangoon to Imphal</span></td>
</tr>
<tr>
<td valign="top"><span href="#/12_chapter3#map3" title="Link target outside of Sample"> 3</span></td>
<td valign="top"><span href="#/12_chapter3#map3" title="Link target outside of Sample">Actions fought in the Prome area</span></td>
</tr>
<tr>
<td valign="top"><span href="#/12_chapter3#map4" title="Link target outside of Sample"> 4</span></td>
<td valign="top"><span href="#/12_chapter3#map4" title="Link target outside of Sample">The battle of Yenaungyaung</span></td>
</tr>
<tr>
<td valign="top"><span href="#/13_chapter4#map5" title="Link target outside of Sample"> 5</span></td>
<td valign="top"><span href="#/13_chapter4#map5" title="Link target outside of Sample">First and Second Arakan Campaigns</span></td>
</tr>
<tr>
<td valign="top"><span href="#/15_chapter6#map6" title="Link target outside of Sample"> 6</span></td>
<td valign="top"><span href="#/15_chapter6#map6" title="Link target outside of Sample">The Imphal Plain</span></td>
</tr>
<tr>
<td valign="top"><span href="#/15_chapter6#map7" title="Link target outside of Sample"> 7</span></td>
<td valign="top"><span href="#/15_chapter6#map7" title="Link target outside of Sample">The battle for Nunshigum</span></td>
</tr>
<tr>
<td valign="top"><span href="#/16_chapter7#map8" title="Link target outside of Sample"> 8</span></td>
<td valign="top"><span href="#/16_chapter7#map8" title="Link target outside of Sample">Kohima: actions fought by 149 Regiment RAC</span></td>
</tr>
<tr>
<td valign="top"><span href="#/17_chapter8#map9" title="Link target outside of Sample"> 9</span></td>
<td valign="top"><span href="#/17_chapter8#map9" title="Link target outside of Sample">4 Corps’ operations aimed at Meiktila</span></td>
</tr>
<tr>
<td valign="top"><span href="#/18_chapter9#map10" title="Link target outside of Sample">10</span></td>
<td valign="top"><span href="#/18_chapter9#map10" title="Link target outside of Sample">The capture of Meiktila</span></td>
</tr>
<tr>
<td valign="top"><span href="#/19_chapter10#map11" title="Link target outside of Sample">11</span></td>
<td valign="top"><span href="#/19_chapter10#map11" title="Link target outside of Sample">The battle of the Irrawaddy Bend: 33 Corps Divisional bridgeheads</span></td>
</tr>
<tr>
<td valign="top"><span href="#/20_chapter11#map12" title="Link target outside of Sample">12</span></td>
<td valign="top"><span href="#/20_chapter11#map12" title="Link target outside of Sample">Arakan – final offensive, 1944–45</span></td>
</tr>
<tr>
<td valign="top"><span href="#/21_chapter12#map13" title="Link target outside of Sample">13</span></td>
<td valign="top"><span href="#/21_chapter12#map13" title="Link target outside of Sample">The advance on Rangoon</span></td>
</tr>
<tr>
<td valign="top"><span href="#/21_chapter12#map14" title="Link target outside of Sample">14</span></td>
<td valign="top"><span href="#/21_chapter12#map14" title="Link target outside of Sample">17 Division breaks the enemy front at Pyawbwe</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_maps.vue?3224f9da